import { useState } from 'react';
import { Play, ArrowRight, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BACKTEST } from '../../config/site';
import { SectionHeader } from '../common';

export default function BacktestingSection() {
  const [running, setRunning] = useState(false);
  const run = () => { setRunning(true); setTimeout(() => setRunning(false), 1500); };
  const b = BACKTEST;
  const eq = b.equity; const w = 100, h = 100; const min = Math.min(...eq), max = Math.max(...eq);
  const step = w / (eq.length - 1);
  const line = eq.map((v, i) => `${i * step},${h - ((v - min) / (max - min)) * 88 - 6}`).join(' ');

  const stats = [
    { label: 'Initial Capital', value: b.initial }, { label: 'Net Profit', value: b.netProfit, color: 'var(--emerald)' },
    { label: 'Win Rate', value: b.winRate, color: 'var(--gold-2)' }, { label: 'Profit Factor', value: b.profitFactor },
    { label: 'Max Drawdown', value: b.maxDD, color: 'var(--down)' }, { label: 'Total Trades', value: b.trades },
  ];

  return (
    <section className="section" style={{ background: 'var(--bg-2)', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)' }}>
      <div className="container-x">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="reveal">
            <SectionHeader eyebrow="Backtesting" title="Don't guess. Backtest." sub="Validate any strategy against historical data with institutional metrics and an interactive equity curve. Sample figures are illustrative — not actual Kalki performance." />
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-8">
              {stats.map((s) => (
                <div key={s.label} className="panel p-4">
                  <div className="font-mono text-[10px] text-[var(--muted-2)] tracking-wide">{s.label.toUpperCase()}</div>
                  <div className="font-display text-[20px] font-bold mt-1" style={{ color: s.color || 'var(--white)' }}>{s.value}</div>
                </div>
              ))}
            </div>
            <div className="mt-8"><Link to="/backtesting" className="btn-gold inline-flex items-center gap-2 rounded-xl h-12 px-7 text-[15px] font-semibold">Run a Backtest <ArrowRight size={16} /></Link></div>
          </div>

          <div className="panel p-5 reveal" style={{ boxShadow: '0 30px 90px rgba(0,0,0,0.5)' }}>
            <div className="flex items-center justify-between mb-4">
              <span className="font-mono text-[12px] text-[var(--muted)]">EQUITY CURVE · Multi-Factor AI</span>
              <button onClick={run} disabled={running} className="btn-gold rounded-lg h-9 px-4 text-[13px] flex items-center gap-1.5">{running ? <><Loader2 size={14} className="animate-spin" /> Running</> : <><Play size={13} /> Run</>}</button>
            </div>
            <div className="h-[240px] panel-2 p-3" style={{ opacity: running ? 0.4 : 1, transition: 'opacity .4s' }}>
              <svg viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" className="w-full h-full">
                <defs><linearGradient id="eqf" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="rgba(25,195,125,0.28)" /><stop offset="100%" stopColor="rgba(25,195,125,0)" /></linearGradient></defs>
                <polygon points={`0,${h} ${line} ${w},${h}`} fill="url(#eqf)" />
                <polyline points={line} fill="none" stroke="#22c55e" strokeWidth="0.9" vectorEffect="non-scaling-stroke" />
              </svg>
            </div>
            <div className="flex items-center justify-between mt-4 font-mono text-[12px]">
              <span className="text-[var(--muted-2)]">Risk / Reward</span><span className="gold-text">{b.rr}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
